import { TCompanyBillingDestinationReqDto, TCreateCompanyReqDto } from "@/api/services/main/company/dtos/create-company.dto";
import { TBillingRecipientRow, TCompanyForm } from "@/features/company/types/company-form";
import { convertZipCodeToNumber } from "@/utils/input";

/** 空文字は送らず null にする（サーバーは nullable な任意項目として扱う）。 */
const toNullable = (value?: string | null): string | null => (value?.trim() ? value.trim() : null);

/** 郵便番号はハイフンを除いた7桁で送る。 */
const toZipCode = (value?: string | null): string | null => (value ? (convertZipCodeToNumber(value) ?? null) : null);

/** 電話番号はハイフン無しの数字だけで送る（090-1234-5678 → 09012345678）。未入力は null。 */
const toPhoneNumber = (value?: string | null): string | null => {
  const digits = value?.replace(/\D/g, "");
  return digits ? digits : null;
};

const toId = (value?: string | null): number | null => (value?.trim() ? Number(value) : null);

/** 「1〜31」の日付入力を数値へ。未入力は null。 */
const toDayOfMonth = (value?: string): number | null => (value?.trim() ? Number(value) : null);

const toBillingDestination = (row: TBillingRecipientRow): TCompanyBillingDestinationReqDto => ({
  locationType: toNullable(row.locationType),
  locationName: row.locationName.trim(),
  addressee: toNullable(row.addressee),
  zipCode: toZipCode(row.zipCode),
  prefecture: toNullable(row.prefecture),
  city: toNullable(row.city),
  address: toNullable(row.addressDetail),
  contactPerson: toNullable(row.contactPerson),
  email: toNullable(row.email),
});

export const convertFormDataToCreateCompanyReqDto = (form: TCompanyForm): TCreateCompanyReqDto => ({
  status: toNullable(form.status),
  companySpecificIndustryId: toId(form.companySpecificIndustryId),
  companyName: form.companyName.trim(),
  companyKanaName: toNullable(form.companyKanaName),
  contactPersonName: toNullable(form.contactPerson),
  contactPersonEmail: toNullable(form.email),
  contactPersonPhone: toPhoneNumber(form.phoneNumber),
  zipCode: toZipCode(form.zipCode),
  prefecture: toNullable(form.prefecture),
  city: toNullable(form.city),
  address: toNullable(form.addressDetail),

  billingAddressee: toNullable(form.billingAddressee),
  billingAddress: toNullable(form.billingLocation),
  billingGrouping: toNullable(form.billingGrouping),
  travelExpenseBilling: toNullable(form.travelExpenseBilling),

  mainPersonInChargeId: toId(form.mainPersonInChargeId),
  registrationMethod: toNullable(form.registrationMethod),

  billingDay: toDayOfMonth(form.invoiceDay),
  paymentDueDay: toDayOfMonth(form.paymentDueDay),
  billingDayMonthOffset: toNullable(form.invoiceDateMonthOffset),
  paymentDueDayMonthOffset: toNullable(form.paymentDueMonthOffset),
  joiningMonthHandling: toNullable(form.joinMonthHandling),
  resignationMonthHandling: toNullable(form.leaveMonthHandling),
  temporaryReturnHandling: toNullable(form.temporaryReturnHandling),
  leaveOfAbsenceHandling: toNullable(form.leaveOfAbsenceHandling),

  importantMemo: toNullable(form.importantMemo),
  note: toNullable(form.companyMemo),

  billingDestinations: form.billingRecipients.map(toBillingDestination),
});
